import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'atlas-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() matIcon: string;
  @Input() logoUrl: string;
  @Input() productName: string;
  iconType: string;

  ngOnInit(): void {
    if (!!this.matIcon) {
      this.iconType = 'matIcon';
    } else if (!!this.logoUrl) {
      this.iconType = 'logoUrl';
    } else if (this.productName && !this.matIcon && !this.logoUrl) {
      this.iconType = 'generated';
    }
  }

  public getAbbreviationForName(): string {
    const defaultAbbreviation = 'U';
    if (this.productName) {
      const names = this.productName.split(' ');
      return names.length > 1 ? names[0][0] + names[1][0] : names[0][0];
    }
    return defaultAbbreviation;
  }

  getIconColorForName(): string {
    const COLOR_CODES = [
      '#EF5350', '#42A5F5', '#66BB6A', '#FFA726', '#AB47BC', '#FFCA28', '#EC407A', '#26C6DA',
      '#FF7B57'
    ];
    let nameSum = 0;
    const defaultColor = '#808080';
    if (!this.productName) {
      return defaultColor;
    }
    for (let i = 0; i < this.productName.length; i++) {
      nameSum += this.productName[i].charCodeAt(0);
    }
    const index = nameSum % COLOR_CODES.length;

    return COLOR_CODES[index];
  }
}
